export default "__VITE_ASSET__Bw7LKo5j__"